var map = {
	"./arrow.png": 97157,
	"./browser_toolbar.png": 51831,
	"./browser_toolbar_dark.png": 92148,
	"./browser_toolbar_edge.png": 88289,
	"./browser_toolbar_safari.png": 71641
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 13738;